import { call, put } from 'redux-saga/effects';
import api, { apiKey } from '../../services/api';

import { Creators as SitesCreators } from '../ducks/sites';
import { Creators as MessagesCreators } from '../ducks/messages';

export function* getSite() {
  const response = yield call(api.get, `v1/sites/${apiKey}`);
  if (response.ok) {
    yield put(SitesCreators.getSiteSuccess(response.data));
  } else {
    yield put(MessagesCreators.setMessage('Houve um erro inesperado! Tente novamente. Cod. #E523'));
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/sites.js